import { render, staticRenderFns } from "./totalLucroLiquido.vue?vue&type=template&id=0d4a70f6&scoped=true&"
import script from "./totalLucroLiquido.vue?vue&type=script&lang=js&"
export * from "./totalLucroLiquido.vue?vue&type=script&lang=js&"
import style0 from "./totalLucroLiquido.vue?vue&type=style&index=0&id=0d4a70f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a70f6",
  null
  
)

export default component.exports